import React from "react";
import { FormattedMessage } from "react-intl";
import Icon from "../../Utils/Icon";
import Loader from "../../Utils/Loader";

import classes from "./styles.module.css";

function AccountsFilters({ onSelectFilter, onApplyFilters, isLoading }) {
    return (
        <div className={classes.Card}>
            <div className={classes.Body}>
                <div className={classes.Group}>
                    <h6 className={classes.Title}>
                        <FormattedMessage id="AccountsFilters.title.status" defaultMessage="Статус" />
                    </h6>

                    <div className={classes.Column}>
                        <div className={classes.CheckboxWrap}>
                            <input
                                id="active"
                                type="checkbox"
                                onChange={(e) => onSelectFilter({ active: e.target.checked })}
                            />
                            <label htmlFor="active" className={classes.CustomCheckbox}>
                                <div className={classes.ActiveIcon} />
                                <span>
                                    <FormattedMessage id="AccountsFilters.status.active" defaultMessage="Активен" />
                                </span>
                            </label>
                        </div>

                        <div className={classes.CheckboxWrap}>
                            <input
                                id="inactive"
                                type="checkbox"
                                onChange={(e) => onSelectFilter({ inactive: e.target.checked })}
                            />
                            <label htmlFor="inactive" className={classes.CustomCheckbox}>
                                <div className={classes.InactiveIcon} />
                                <span>
                                    <FormattedMessage
                                        id="AccountsFilters.status.inactive"
                                        defaultMessage="Не активен"
                                    />
                                </span>
                            </label>
                        </div>

                        <div className={classes.CheckboxWrap}>
                            <input
                                id="closed"
                                type="checkbox"
                                onChange={(e) => onSelectFilter({ closed: e.target.checked })}
                            />
                            <label htmlFor="closed" className={classes.CustomCheckbox}>
                                <div className={classes.ClosedIcon} />
                                <span>
                                    <FormattedMessage id="AccountsFilters.status.closed" defaultMessage="Закрыт" />
                                </span>
                            </label>
                        </div>

                        <div className={classes.CheckboxWrap}>
                            <input
                                id="blocked"
                                type="checkbox"
                                onChange={(e) => onSelectFilter({ blocked: e.target.checked })}
                            />
                            <label htmlFor="blocked" className={classes.CustomCheckbox}>
                                <div className={classes.BlockIcon} />
                                <span>
                                    <FormattedMessage
                                        id="AccountsFilters.status.blocked"
                                        defaultMessage="Заблокирован"
                                    />
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div className={classes.Footer}>
                <button onClick={onApplyFilters} className={classes.Submit} disabled={isLoading}>
                    {!isLoading ? <Icon className={classes.buttonIcon} icon="filter" size={"17px"} /> : <Loader isString={true} />}
                    <FormattedMessage id="AccountsFilters.btn.filter" defaultMessage="Фильтровать" />
                </button>
            </div>
        </div>
    );
}

export default AccountsFilters;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/AccountsFilters/index.js